import FlexboxContainer from './FlexboxContainer'
import FlexboxChild from './FlexboxChild'

const Flexbox = {
    Child: FlexboxChild,
    Container: FlexboxContainer,
}

export default Flexbox
